import { createContext, useContext, useState, useMemo, useCallback } from "react";

export const translations = {
  it: {
    nav: { home: "Home", about: "Chi siamo", gallery: "Sistemazioni", reviews: "Recensioni", contact: "Prenota" },
    hero: {
      overline: "LA TUA CASA VACANZE A NEGRIL",
      title: "R&V VILLA",
      subtitle: "situata a Negril sulla famosa Norman Manley blv oppure conosciuta come Seven Miles beach road",
      cta: "Prenota Ora",
      scroll: "Scopri di più",
    },
    about: {
      kicker: "Benvenuti",
      title: "Benvenuti a R&V VILLA !",
      intro: "Ciao, siamo Valeria e Richard e siamo felici di darvi il benvenuto nel nostro “yard” (la nostra proprietà)!",
      who_title: "Chi siamo",
      who_body: "Io sono italiana e mio marito è giamaicano. Insieme abbiamo una splendida figlia.\nLa nostra proprietà offre un'atmosfera autentica e familiare. Viviamo qui, in una casa indipendente all'interno della proprietà, insieme alla famiglia di mio marito, e saremo sempre a vostra disposizione durante il soggiorno per qualsiasi necessità.\n\nCi piace accogliere personalmente i nostri ospiti e aiutarli a scoprire il meglio della Giamaica, consigliando spiagge, ristoranti, escursioni e luoghi da visitare. Saremo felici di condividere suggerimenti e informazioni utili per rendere la vostra vacanza il più piacevole possibile.",
      property_title: "La proprietà",
      property_body: "La struttura si trova sul lato interno (lato terra) di Seven Mile Beach. È un tipico “yard” giamaicano, accogliente e sicuro, ideale per chi vuole vivere l'autentica atmosfera dell'isola in un ambiente confortevole e protetto.",
      beach_title: "La spiaggia",
      beach_body: "Si trova a soli 100 metri da noi, proprio dall'altro lato della strada.",
      nature_title: "Natura e Relax",
      nature_body: "La proprietà è immersa in un bellissimo giardino dove potrete rilassarvi e godervi la natura circostante. Perfetto anche per gli amanti del birdwatching, da cui potrete ammirare una splendida vista sul “Morass” (la riserva naturale della palude).",
      nature_cta: "Tocca per vedere il Morass",
      location_title: "Posizione",
      location_body: "Ci troviamo in una posizione strategica, vicina sia al centro che alle principali attrazioni che Negril ha da offrire.",
      location_city: "Il centro città è raggiungibile a piedi in soli 10–15 minuti.",
      location_sea: "La spiaggia è proprio di fronte a noi, a meno di 100 metri. Vi basterà attraversare la strada per trovarvi sulla splendida Seven Mile Beach di Negril.",
      open_in_maps: "Apri in Maps →",
    },
    gallery: {
      kicker: "Le nostre sistemazioni",
      title: "Tre modi di vivere la Giamaica",
      lead: "Offriamo tre diverse opzioni di alloggio, ognuna con il suo carattere autentico.",
      view_photos: "Vedi tutte le foto",
      photo_singular: "foto", photo_plural: "foto",
      amenities_title: "Servizi inclusi",
      amenities: {
        ac: "Aria condizionata", ac_each: "A/C in ogni camera",
        ceiling_fan: "Ventilatore a soffitto", ceiling_fan_each: "Ventilatore a pala in ogni camera",
        wall_fan: "Ventilatore a muro",
        smart_tv: "Smart TV", smart_tv_each: "Smart TV in ogni camera", smart_cable_tv: "Smart TV + Cable TV",
        wifi: "Wi-Fi gratuito",
        fridge: "Frigorifero", gas_stove_oven: "Cucina a gas con forno",
        gas_stove_2: "Cucinetta esterna a 2 fuochi gas",
        microwave: "Microonde", blender: "Frullatore", kettle: "Bollitore elettrico",
        toaster: "Tostapane", air_fryer: "Air Fryer",
        full_kitchen: "Cucina completa moderna", kitchen_equipped: "Cucina attrezzata",
        kitchenware: "Piatti, bicchieri, posate e pentole",
        linens: "Lenzuola e asciugamani", sofa_bed: "Divano letto singolo",
      },
      items: [
        { tag: "01", name: "Casa con due camere da letto", desc: "Dispone di due camere da letto con un bagno privato in ogni camera, una zona giorno con cucina e una veranda esterna.", features: ["2 camere", "2 bagni privati", "Zona giorno + cucina", "Veranda esterna"] },
        { tag: "02", name: "Casa con una camera da letto", desc: "Camera con bagno privato e veranda esterna con un piccolo angolo cottura.", features: ["1 camera", "Bagno privato", "Angolo cottura", "Veranda esterna"] },
        { tag: "03", name: "Appartamento con una camera da letto", desc: "Offre una cucina completa con soggiorno, una camera con un letto matrimoniale queen, un bagno e un'ampia e piacevole veranda.", features: ["1 camera (queen)", "Bagno privato", "Cucina completa", "Soggiorno", "Ampia veranda"] },
      ],
    },
    reviews: {
      kicker: "Cosa dicono i nostri ospiti",
      title: "Recensioni autentiche, dalla famiglia R&V",
      lead: "Recensioni reali raccolte dalle pagine pubbliche di Booking.com e Airbnb (2025-2026).",
      summary: "9.2/10 · 29+ recensioni verificate",
      via: "via",
      prev: "Precedente", next: "Successiva",
      form: {
        kicker: "Hai soggiornato da noi?",
        title: "Lascia la tua recensione",
        lead: "La tua recensione verrà inviata per approvazione prima della pubblicazione. Grazie per condividere la tua esperienza!",
        name: "Nome",
        email: "Email (privata, non sarà pubblicata)",
        period: "Periodo del soggiorno",
        period_ph: "es. Aprile 2026",
        rating: "Voto",
        text: "La tua recensione",
        text_ph: "Raccontaci com'è stato il tuo soggiorno...",
        submit: "Invia recensione",
        submitting: "Invio in corso...",
        success: "Grazie! La tua recensione è stata inviata per approvazione.",
        error: "Si è verificato un errore. Riprova più tardi.",
      },
    },
    contact: {
      kicker: "Prenota il tuo soggiorno",
      title: "Scriveteci, vi rispondiamo personalmente",
      lead: "Compila il modulo o scrivici direttamente su WhatsApp. Saremo felici di aiutarvi a pianificare la vostra vacanza in Giamaica.",
      note: "Per richieste ufficiali di prenotazione e disponibilità compila il form qui sotto. Per ulteriori domande, chiarimenti o informazioni veloci, puoi contattarci anche direttamente sul nostro numero WhatsApp.",
      form: {
        name: "Nome e cognome", email: "Email", phone: "Telefono (opzionale)",
        check_in: "Check-in", check_out: "Check-out", guests: "Ospiti",
        accommodation: "Sistemazione",
        accommodation_options: { any: "Sono flessibile", "2br_house": "Casa 2 camere", "1br_house": "Casa 1 camera", "1br_apartment": "Appartamento 1 camera" },
        message: "Messaggio", message_ph: "Raccontaci di voi, date, esigenze...",
        submit: "Invia richiesta", submitting: "Invio in corso...",
        whatsapp: "Scrivici su WhatsApp", email_btn: "Inviaci un'email",
        success: "Richiesta inviata! Vi ricontatteremo al più presto.",
        error: "Si è verificato un errore. Riprova o scrivici su WhatsApp.",
      },
    },
    footer: { tagline: "La tua casa vacanze a Negril, Giamaica", address: "Norman Manley Blv (Seven Miles Beach Road), Negril, Jamaica", rights: "Tutti i diritti riservati.", made: "Realizzato con cura per i nostri ospiti.", privacy: "Privacy Policy" },
    privacy: {
      title: "Informativa sulla Privacy",
      subtitle: "La presente Informativa descrive le modalità di trattamento dei dati personali degli utenti che visitano il sito rv-villa.com.",
      sections: [
        { title: "Titolare del Trattamento", body: "Il titolare del trattamento è Valeria Bolognesi Hill (R&V VILLA, Negril, Giamaica)." },
        { title: "Dati Raccolti", body: "Il sito raccoglie dati forniti volontariamente tramite moduli di contatto o email e dati di navigazione standard (es. indirizzi IP)." },
        { title: "Finalità", body: "I dati sono usati solo per rispondere alle richieste degli utenti o garantire la sicurezza del sito." },
        { title: "Diritti", body: "Gli utenti possono richiedere in ogni momento la verifica, la modifica o la cancellazione dei propri dati." },
      ],
      contact: "Per esercitare i tuoi diritti scrivici a rvvilla2020@gmail.com",
      close: "Chiudi",
    },
    admin: {
      login_title: "Accesso pannello admin",
      login_lead: "Accedi con il tuo account Google autorizzato per gestire prenotazioni e recensioni.",
      login_btn: "Accedi con Google",
      not_authorized: "Email non autorizzata come admin.",
      dashboard: "Dashboard",
      logout: "Esci",
      pending: "In attesa", approved: "Approvate", rejected: "Rifiutate",
      bookings: "Prenotazioni", reviews: "Recensioni",
      approve: "Approva", reject: "Rifiuta", delete: "Elimina",
      no_items: "Nessun elemento.",
    },
  },
  en: {
    nav: { home: "Home", about: "About", gallery: "Stays", reviews: "Reviews", contact: "Book" },
    hero: {
      overline: "YOUR VACATION HOME IN NEGRIL",
      title: "R&V VILLA",
      subtitle: "located in Negril on the famous Norman Manley blv also known as Seven Mile beach road",
      cta: "Book Now", scroll: "Discover more",
    },
    about: {
      kicker: "Welcome",
      title: "Welcome to R&V VILLA !",
      intro: "Hi, we are Valeria and Richard and we are happy to welcome you to our “yard” (our property)!",
      who_title: "About us",
      who_body: "I am Italian and my husband is Jamaican. Together we have a wonderful daughter.\nOur property offers an authentic, family atmosphere. We live here, in a separate house within the property, together with my husband's family, and we will always be available during your stay for anything you may need.\n\nWe love welcoming our guests personally and helping them discover the best of Jamaica — recommending beaches, restaurants, excursions and places to visit. We'll be happy to share tips and useful information to make your vacation as pleasant as possible.",
      property_title: "The property",
      property_body: "The property sits on the inland side (land side) of Seven Mile Beach. It's a typical Jamaican “yard”, welcoming and safe, ideal for those who want to experience the authentic island atmosphere in a comfortable and protected environment.",
      beach_title: "The beach",
      beach_body: "It's only 100 meters away, right across the street.",
      nature_title: "Nature & Relax",
      nature_body: "The property is surrounded by a beautiful garden where you can relax and enjoy the surrounding nature. Perfect also for birdwatching lovers, from where you can admire a splendid view of the “Morass” (the natural swamp reserve).",
      nature_cta: "Tap to see the Morass",
      location_title: "Location",
      location_body: "We're in a strategic location, close to both downtown and the main attractions Negril has to offer.",
      location_city: "Downtown is reachable on foot in just 10–15 minutes.",
      location_sea: "The beach is right in front of us, less than 100 meters away. Just cross the road and you'll find yourself on the splendid Seven Mile Beach of Negril.",
      open_in_maps: "Open in Maps →",
    },
    gallery: {
      kicker: "Our accommodations",
      title: "Three ways to live Jamaica",
      lead: "We offer three different accommodation options, each with its own authentic character.",
      view_photos: "View all photos",
      photo_singular: "photo", photo_plural: "photos",
      amenities_title: "Amenities included",
      amenities: {
        ac: "Air conditioning", ac_each: "A/C in each bedroom",
        ceiling_fan: "Ceiling fan", ceiling_fan_each: "Ceiling fan in each bedroom",
        wall_fan: "Wall fan",
        smart_tv: "Smart TV", smart_tv_each: "Smart TV in each bedroom", smart_cable_tv: "Smart TV + Cable TV",
        wifi: "Free Wi-Fi",
        fridge: "Refrigerator", gas_stove_oven: "Gas stove with oven",
        gas_stove_2: "Outdoor 2-burner gas kitchenette",
        microwave: "Microwave", blender: "Blender", kettle: "Electric kettle",
        toaster: "Toaster", air_fryer: "Air fryer",
        full_kitchen: "Modern full kitchen", kitchen_equipped: "Equipped kitchen",
        kitchenware: "Plates, glasses, cutlery & pots",
        linens: "Bed linens & towels", sofa_bed: "Single sofa bed",
      },
      items: [
        { tag: "01", name: "Two-bedroom house", desc: "Features two bedrooms, each with a private bathroom, a living area with kitchen and an outdoor veranda.", features: ["2 bedrooms", "2 private bathrooms", "Living + kitchen", "Outdoor veranda"] },
        { tag: "02", name: "One-bedroom house", desc: "Bedroom with private bathroom and outdoor veranda with a small kitchenette.", features: ["1 bedroom", "Private bathroom", "Kitchenette", "Outdoor veranda"] },
        { tag: "03", name: "One-bedroom apartment", desc: "Offers a full kitchen with living room, a bedroom with a queen-size bed, a bathroom and a large pleasant veranda.", features: ["1 bedroom (queen)", "Private bathroom", "Full kitchen", "Living room", "Large veranda"] },
      ],
    },
    reviews: {
      kicker: "What our guests say",
      title: "Real reviews from the R&V family",
      lead: "Real reviews collected from our public Booking.com and Airbnb pages (2025-2026).",
      summary: "9.2/10 · 29+ verified reviews",
      via: "via",
      prev: "Previous", next: "Next",
      form: {
        kicker: "Have you stayed with us?",
        title: "Leave your review",
        lead: "Your review will be sent for approval before being published. Thank you for sharing your experience!",
        name: "Name",
        email: "Email (private, not published)",
        period: "Stay period",
        period_ph: "e.g. April 2026",
        rating: "Rating",
        text: "Your review",
        text_ph: "Tell us about your stay...",
        submit: "Submit review",
        submitting: "Submitting...",
        success: "Thank you! Your review has been sent for approval.",
        error: "Something went wrong. Please try again later.",
      },
    },
    contact: {
      kicker: "Book your stay",
      title: "Write to us, we reply personally",
      lead: "Fill out the form or message us directly on WhatsApp. We'll be happy to help you plan your Jamaican vacation.",
      note: "For official booking requests and availability please fill out the form below. For any other questions, clarifications or quick information, you can also contact us directly on our WhatsApp number.",
      form: {
        name: "Full name", email: "Email", phone: "Phone (optional)",
        check_in: "Check-in", check_out: "Check-out", guests: "Guests",
        accommodation: "Accommodation",
        accommodation_options: { any: "I'm flexible", "2br_house": "2-bedroom house", "1br_house": "1-bedroom house", "1br_apartment": "1-bedroom apartment" },
        message: "Message", message_ph: "Tell us about yourself, dates, special needs...",
        submit: "Send request", submitting: "Sending...",
        whatsapp: "Message us on WhatsApp", email_btn: "Send us an email",
        success: "Request sent! We'll get back to you as soon as possible.",
        error: "Something went wrong. Please try again or message us on WhatsApp.",
      },
    },
    footer: { tagline: "Your vacation home in Negril, Jamaica", address: "Norman Manley Blv (Seven Miles Beach Road), Negril, Jamaica", rights: "All rights reserved.", made: "Made with care for our guests.", privacy: "Privacy Policy" },
    privacy: {
      title: "Privacy Policy",
      subtitle: "This notice describes how personal data of users visiting rv-villa.com is processed.",
      sections: [
        { title: "Data Controller", body: "The data controller is Valeria Bolognesi Hill (R&V VILLA, Negril, Jamaica)." },
        { title: "Data Collected", body: "The site collects data voluntarily provided through contact forms or email, and standard browsing data (e.g. IP addresses)." },
        { title: "Purposes", body: "Data is used only to respond to user requests or ensure the security of the site." },
        { title: "Your Rights", body: "Users can request at any time verification, modification or deletion of their personal data." },
      ],
      contact: "To exercise your rights, write to rvvilla2020@gmail.com",
      close: "Close",
    },
    admin: {
      login_title: "Admin login",
      login_lead: "Sign in with your authorized Google account to manage bookings and reviews.",
      login_btn: "Sign in with Google",
      not_authorized: "Email not authorized as admin.",
      dashboard: "Dashboard",
      logout: "Sign out",
      pending: "Pending", approved: "Approved", rejected: "Rejected",
      bookings: "Bookings", reviews: "Reviews",
      approve: "Approve", reject: "Reject", delete: "Delete",
      no_items: "No items.",
    },
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "it";
    return window.localStorage.getItem("rvvilla_lang") || "it";
  });
  const toggle = useCallback((next) => {
    setLang((prev) => {
      const v = next || (prev === "it" ? "en" : "it");
      try { window.localStorage.setItem("rvvilla_lang", v); } catch { /* noop */ }
      return v;
    });
  }, []);
  const value = useMemo(() => ({ lang, setLang: toggle, t: translations[lang] }), [lang, toggle]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
  return ctx;
}
